import React, { useState, useEffect } from "react";
import Select from "react-select";
const FilterComponent = ({ works, closeProjects, setFilteredWorks }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  useEffect(() => {
    if (selectedOption && selectedOption.value !== null) {
      setFilteredWorks(
        works.filter((work) => {
          return work.tags.includes(selectedOption.value);
        })
      );
    } else {
      setFilteredWorks(works);
    }
  }, [selectedOption]);
  const techOptions = [
    { value: null, label: "Show All" },
    { value: "fullstack", label: "Fullstack" },
    { value: "react", label: "ReactJS" },
    { value: "nextjs", label: "NextJS" },
  ];
  return (
    <div className="flex justify-between w-[80vw] mb-5  max-w-6xl">
      <div className="hover:cursor-pointer" onClick={() => closeProjects()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          width="35"
          height="35"
          fill="white"
        >
          <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" />
        </svg>
      </div>

      <div>
        <Select
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              fontFamily: "Raleway",

              backgroundColor: "#6d28d9",
              color: "white !important",
              cursor: "pointer",
            }),
            placeholder: (baseStyles, state) => ({
              ...baseStyles,

              color: "white !important",
            }),
            singleValue: (baseStyles, state) => ({
              ...baseStyles,
              color: "white !important",
              fontFamily: "Raleway",
            }),
            Svg: (baseStyles, state) => (
              {
                ...baseStyles,
                color: "white !important",
              },
              state.isHover ? "white" : "white"
            ),
          }}
          placeholder={techOptions[0].label}
          value={selectedOption}
          className="basic-single hover:cursor-pointer"
          classNamePrefix="select "
          // defaultValue={selectedOption}
          // isLoading={isLoading}
          // isClearable={isClearable}
          // isRtl={isRtl}

          // name="color"
          // controlShouldRenderValue={true}
          onChange={(e) => {
            setSelectedOption(e);
          }}
          options={techOptions}
        />
      </div>
    </div>
  );
};

export default FilterComponent;
